/* eslint-disable */

function extend() {
  for (let i = 1; i < arguments.length; i++) {
    for (const key in arguments[i]) {
      if (arguments[i].hasOwnProperty(key)) {
        if (typeof arguments[0][key] === 'object'
                  && typeof arguments[i][key] === 'object') extend(arguments[0][key], arguments[i][key]);
        else arguments[0][key] = arguments[i][key];
      }
    }
  }
  return arguments[0];
}

/*
    JavaScript flexImages v1.0.2
    Copyright (c) 2014 Simon Steinberger / Pixabay
    GitHub: https://github.com/Pixabay/JavaScript-flexImages
    License: http://www.opensource.org/licenses/mit-license.php
*/

const flexImages = (function () {
  // "use strict";
  function flexImages(options) {
    if (!document.querySelector) return;

    function makeGrid(grid, items, o, noresize) {
      let x; let new_w; let exact_w;
      let ratio = 1;
      let rows = 1;
      const max_w = grid.clientWidth - 2;
      let row = [];
      let row_width = 0;
      let h;
      let row_h = o.rowHeight;

      // define inside makeGrid to access variables in scope
      function _helper(lastRow) {
        if (o.maxRows && rows > o.maxRows || o.truncate && lastRow && rows > 1) row[x][0].style.display = 'none';
        else {
          if (row[x][4]) { row[x][3].setAttribute('src', row[x][4]); row[x][4] = ''; }
          row[x][0].style.width = `${new_w}px`;
          row[x][0].style.height = `${row_h}px`;
          row[x][0].style.display = 'block';
        }
      }

      for (let i = 0; i < items.length; i++) {
        row.push(items[i]);
        row_width += items[i][2] + o.margin;
        if (row_width >= max_w) {
          const margins_in_row = row.length * o.margin;
          ratio = (max_w - margins_in_row) / (row_width - margins_in_row), row_h = Math.ceil(o.rowHeight * ratio), exact_w = 0, new_w;
          for (x = 0; x < row.length; x++) {
            new_w = Math.ceil(row[x][2] * ratio);
            exact_w += new_w + o.margin;
            if (exact_w > max_w) new_w -= exact_w - max_w;
            _helper();
          }
          // reset for next row
          row = [], row_width = 0;
          rows++;
        }
      }
      // layout last row - match height of last row to previous row
      for (x = 0; x < row.length; x++) {
        new_w = Math.floor(row[x][2] * ratio), h = Math.floor(o.rowHeight * ratio);
        _helper(true);
      }

      // scroll bars added or removed during rendering new layout?
      if (!noresize && max_w != grid.clientWidth) makeGrid(grid, items, o, true);
    }

    const o = {
      selector: 0, container: '.item', object: 'img', rowHeight: 180, maxRows: 0, truncate: 0,
    };
    for (const k in options) { if (options.hasOwnProperty(k)) o[k] = options[k]; }
    const grids = typeof o.selector === 'object' ? [o.selector] : document.querySelectorAll(o.selector);

    for (let i = 0; i < grids.length; i++) {
      var grid = grids[i];
      const containers = grid.querySelectorAll(o.container);
      var items = [];
      const t = new Date().getTime();
      if (!containers.length) continue;
      const s = window.getComputedStyle ? getComputedStyle(containers[0], null) : containers[0].currentStyle;
      o.margin = (parseInt(s.marginLeft) || 0) + (parseInt(s.marginRight) || 0) + (Math.round(parseFloat(s.borderLeftWidth)) || 0) + (Math.round(parseFloat(s.borderRightWidth)) || 0);
      for (let j = 0; j < containers.length; j++) {
        const c = containers[j];
        const w = parseInt(c.getAttribute('data-w'));
        const norm_w = w * (o.rowHeight / parseInt(c.getAttribute('data-h'))); // normalized width
        const obj = c.querySelector(o.object);
        items.push([c, w, norm_w, obj, obj.getAttribute('data-src')]);
      }
      makeGrid(grid, items, o);
      const tempf = function () { makeGrid(grid, items, o); };
      if (document.addEventListener) {
        window[`flexImages_listener${t}`] = tempf;
        window.removeEventListener('resize', window[`flexImages_listener${grid.getAttribute('data-flex-t')}`]);
        delete window[`flexImages_listener${grid.getAttribute('data-flex-t')}`];
        window.addEventListener('resize', window[`flexImages_listener${t}`]);
      } else { grid.onresize = tempf; }
      grid.setAttribute('data-flex-t', t);
    }
  }
  return flexImages;
}());

(function () {
  window.flexImages = flexImages;
}());

/* eslint-enable */

window.ezResourceGrid = function (resourceGridSelector, options, callback = null) {
  const gridOptions = extend({
    container: '.ez-resource-grid__item',
    maxRows: 0,
    object: 'img',
    rowHeight: 180,
    selector: resourceGridSelector,
    truncate: 0,
  }, options);

  window.flexImages(gridOptions);

  const gridItems = resourceGridSelector.querySelectorAll('li');
  if (gridItems.length) resourceGridSelector.classList.remove('is-hidden');
  if (callback) callback();
};
